// @flow
import * as shippingStatuses from 'app/common/actions/shop/order/shippingStatuses';


const getNames = () => ({ // это для будущей локализации
  [shippingStatuses.SHIPPING_STATUS_PROCESSING]: {
    id: shippingStatuses.SHIPPING_STATUS_PROCESSING,
    title: 'Комплектуется',
  },
  [shippingStatuses.SHIPPING_STATUS_WAITING]: {
    id: shippingStatuses.SHIPPING_STATUS_WAITING,
    title: 'Ожидает обработки',
  },
  [shippingStatuses.SHIPPING_STATUS_SHIPPING]: {
    id: shippingStatuses.SHIPPING_STATUS_SHIPPING,
    title: 'Доставляется',
  },
  [shippingStatuses.SHIPPING_STATUS_READY_FOR_ISSUE]: {
    id: shippingStatuses.SHIPPING_STATUS_READY_FOR_ISSUE,
    title: 'Готов к выдаче',
  },
  [shippingStatuses.SHIPPING_STATUS_ISSUED]: {
    id: shippingStatuses.SHIPPING_STATUS_ISSUED,
    title: 'Выдан',
  },
  [shippingStatuses.SHIPPING_STATUS_PARTIALLY_ISSUED]: {
    id: shippingStatuses.SHIPPING_STATUS_PARTIALLY_ISSUED,
    title: 'Частично выдан',
  },
  [shippingStatuses.SHIPPING_STATUS_CANCELED_BY_CUSTOMER]: {
    id: shippingStatuses.SHIPPING_STATUS_CANCELED_BY_CUSTOMER,
    title: 'Отменен заказчиком',
  },
});

export default getNames;
